import cx from 'classnames'
import Styles from './BrandKitRow.module.scss'
import { useImageMenuContext } from '../ImageMenuContext'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Carousel } from 'components/Carousel/Carousel'
import { AlmanacFile } from 'types'
import { Button } from 'blaze-ui/Button'
import { SelectableFile } from '../SelectableFile/SelectableFile'
import { getMediaFiles } from 'components/Design/UploadsTab/getMediaFiles'
import { Item } from 'components/Menu/MenuItem'
import { Select } from 'components/Select/Select'
import { BrandKitLogo } from 'screens/BrandKit/BrandKitLogo/BrandKitLogo'
import { VideoDuration } from 'components/VideoDuration/VideoDuration'
import { useInfiniteBrandKitMediaFiles } from 'hooks/queries/brandKits/useInfiniteBrandKitMediaFiles'
import { collectResults } from 'utils/query'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

const BrandKitRowContent = () => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { setProvider, selectedImages, toggleSelectedImage, brandKitId, setBrandKitId, accept, brandKits } =
    useImageMenuContext()

  const brandKit = brandKits?.find((brandKit) => brandKit.id === brandKitId)
  const mediaFilesQuery = useInfiniteBrandKitMediaFiles({
    brandKitId,
    items: 10,
    order_by: 'recent',
    mime_types: accept,
  })
  const brandKitMediaFiles = collectResults(mediaFilesQuery, (data) => data.media_files)
  const mediaFiles = getMediaFiles(brandKitMediaFiles as AlmanacFile[], accept)

  if (!brandKitId || !brandKits || !brandKit || !mediaFiles.length) {
    return null
  }

  return (
    <div className={cx(Styles.row, Styles.photosRow, Styles.container)}>
      <div className={Styles.rowHeader}>
        <div className={Styles.headingAndTrigger}>
          <Heading level={isSystemRedesignEnabled ? 5 : 4} color="var(--dark-80)">
            From Your Brand Kit
          </Heading>
          <Select
            selectedKey={`${brandKit.id}`}
            onSelectionChange={(key) => setBrandKitId(parseInt(key as string))}
            aria-label="Brand kit"
          >
            {brandKits?.map((brandKit) => (
              <Item key={brandKit.id} textValue={brandKit.name}>
                <div className={Styles.brandKitContainer}>
                  <BrandKitLogo brandKit={brandKit} size={20} />
                  {brandKit.name}
                </div>
              </Item>
            ))}
          </Select>
        </div>
        <Button
          size="sm"
          variant="ghost"
          onPress={() => setProvider('brandKits')}
          data-testid="see-all-brand-kit-media-button"
        >
          See All
        </Button>
      </div>
      <div className={Styles.carouselContainer}>
        <Carousel offset={isSystemRedesignEnabled ? 0 : 20}>
          {mediaFiles.map((mediaFile) => (
            <SelectableFile
              key={mediaFile.id}
              onSelect={() => toggleSelectedImage({ ...mediaFile, url: mediaFile.source_url, provider: 'brandKits' })}
              isSelected={selectedImages.some((i) => i.url === mediaFile.source_url)}
              isUsed={!!mediaFile.last_used_at || !!mediaFile.most_recent_media_usage}
            >
              <img src={mediaFile.thumbnail_url} alt="" />
              {mediaFile.duration && <VideoDuration duration={mediaFile.duration} />}
            </SelectableFile>
          ))}
        </Carousel>
      </div>
    </div>
  )
}

export const BrandKitRow = () => {
  const { hiddenProviders } = useImageMenuContext()

  if (hiddenProviders.includes('brandKits')) return null

  return <BrandKitRowContent />
}
